import { Card, CardContent } from '@/components/ui/card';
import { Error } from '@/components/ui/error';
import { Loading } from '@/components/ui/loading';
import { useCompanies } from '@/data/company';

const Page = () => {
  const companies = useCompanies();

  if (companies.isLoading && !companies.data) {
    return <Loading />;
  }

  if (companies.error) {
    return <Error message="An error occurred loading companies" />;
  }

  const totalCompanies = companies.data.query.length;

  const v2EstimateOnlyCompanies = companies.data.query.filter((companyUid) => companies.data.content[companyUid].is_v2_estimate);

  const bidManagementCompanies = companies.data.query.filter((companyUid) => companies.data.content[companyUid].is_bid_management);

  return (
    <div className="grid grid-cols-5 gap-4">
      <Card>
        <CardContent className="p-4">
          <div className="tracking-tight text-sm font-medium">Total Companies</div>
          <div className="text-2xl font-bold">{totalCompanies}</div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="tracking-tight text-sm font-medium">Estimates</div>
          <div className="text-2xl font-bold">{v2EstimateOnlyCompanies.length}</div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <div className="tracking-tight text-sm font-medium">Bid Management</div>
          <div className="text-2xl font-bold">{bidManagementCompanies.length}</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Page;
